import {GenericList} from './GenericList';
import {Payment} from "../../models/Payment";

export class PaymentList extends GenericList<Payment> {}
